import React from 'react'
import { useMap, MapProps } from './useMap'
import { Link } from 'react-router-dom'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import shadowUrl from 'leaflet/dist/images/marker-shadow.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import 'fontawesome'
import styles from './Map.module.scss'

L.Icon.Default.mergeOptions({
  iconRetinaUrl: '/img/Logos/logo-squared.png',
  shadowUrl,
  iconSize: [44, 44],
})

const Map: React.FC<MapProps> = (props: MapProps) => {
  const { ourBranches, isAr, t } = useMap(props)

  return (
    <section>
      <div className={`container ${styles['map-container']}`}>
        <div className='row justify-content-center'>
          {ourBranches && ourBranches.length ? (
            <div className='col-md-8 col-xl-6 pb-5'>
              <MapContainer
                center={[33.88, window.screen.width < 575 ? 35.57 : 35.8]}
                zoom={9}
                style={{ height: '75vh', width: '100%', borderRadius: '10px' }}
              >
                <TileLayer
                  url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />
                {ourBranches.map((branch, index) => {
                  return (
                    <Marker
                      key={`branch-${branch.id}-${index}`}
                      position={[branch.location.lat, branch.location.lng]}
                    >
                      <Popup>
                        <div
                          dir={isAr ? 'rtl' : 'ltr'}
                          style={{ textAlign: 'start', fontFamily: 'Changa' }}
                        >
                          <div className='d-flex flex-column align-items-center'>
                            <img
                              src={branch.featuredImage}
                              alt={`${branch.titleAr}`}
                              width={200}
                              height={140}
                              style={{
                                borderRadius: '8px',
                                objectFit: 'contain',
                              }}
                            />
                            <h4>{isAr ? branch.titleAr : branch.titleEn}</h4>
                          </div>
                          <div>
                            <p>
                              {isAr
                                ? branch.descriptionAr.length > 0 &&
                                  branch.descriptionAr[0].children &&
                                  branch.descriptionAr[0].children.length > 0
                                  ? `${branch.descriptionAr[0].children[0].text.substring(0, 100)}...`
                                  : t('noDetails')
                                : branch.descriptionEn.length > 0 &&
                                    branch.descriptionEn[0].children &&
                                    branch.descriptionEn[0].children.length > 0
                                  ? `${branch.descriptionEn[0].children[0].text.substring(0, 100)}...`
                                  : t('noDetails')}
                            </p>
                            <Link
                              className={`fs-6 text-decoration-none ${styles.link}`}
                              to={`/BranchDetails/${branch.slugAr}`}
                            >
                              <span>{t('readMore')}</span>
                              <FontAwesomeIcon
                                icon={isAr ? 'arrow-left' : 'arrow-right'}
                                className='ms-2'
                              />
                            </Link>
                          </div>
                        </div>
                      </Popup>
                    </Marker>
                  )
                })}
              </MapContainer>
            </div>
          ) : (
            <div className='col-12 text-center fs-4 fw-bold py-5'>
              {t('noData')}
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default Map
